import { PRESELECT_MEDIA_COUNT } from './constants';
import * as importedActions from './imported/actions';
import { getAllImportedMedia } from './imported/selectors';
import { getSelectedMediaCount } from './selectors';
import { IMediaItem, isUpload } from './types';
import * as uploadsActions from './uploads/actions';
import { getUploads } from './uploads/selectors';

function toggleSelected(item: IMediaItem, selected: boolean) {
  return isUpload(item)
    ? uploadsActions.toggleSelected({ name: item.name, selected })
    : importedActions.toggleSelected({ url: item.url, selected });
}

function toggleSelectedMany(items: IMediaItem[], selected: boolean) {
  return (dispatch) => {
    items.forEach((item) => {
      dispatch(toggleSelected(item, selected));
    });
  };
}

function preselectImportedMedia() {
  return (dispatch, getState) => {
    const state = getState();
    const selectedCount = getSelectedMediaCount(state);
    const uploadedMedia = getUploads(state);

    if (selectedCount === 0 && uploadedMedia.length === 0) {
      dispatch(
        importedActions.preselectImportedMedia(
          getAllImportedMedia(state)
            .slice(0, PRESELECT_MEDIA_COUNT)
            .map((i) => i.url),
        ),
      );
    }
  };
}

export * from './imported/operations';
export * from './uploads/operations';
export { toggleSelectedMany, preselectImportedMedia };
